import styles from './TopBar.module.scss';

interface TopBarProps {
  readonly variant?: 'deslogado' | 'logado';
}

export function TopBar({ variant = 'deslogado' }: TopBarProps) {
  return (
    <div
      className={`${styles.topbar} ${variant === 'logado' ? styles.logado : styles.deslogado}`}
    >
      <div className={styles.inner}>
        <div className={styles.group}>
          <p className={styles.brand}>BRASIL</p>
          <a
            className={styles.link}
            href='https://www.gov.br/acessoainformacao/pt-br'
            target='_blank'
            rel='noreferrer'
          >
            Acesso à informação
          </a>
        </div>
        <div className={`${styles.group} ${styles.right}`}>
          <a
            className={styles.link}
            href='https://brasilparticipativo.presidencia.gov.br/'
            target='_blank'
            rel='noreferrer'
          >
            Participe
          </a>
          <a
            className={styles.link}
            href='https://www4.planalto.gov.br/legislacao'
            target='_blank'
            rel='noreferrer'
          >
            Legislação
          </a>
        </div>
      </div>
    </div>
  );
}
